export function canShowChangeExamType(appToBuild: string): boolean {
  return appToBuild !== "ibew_aptitude";
}

export function shouldShowChangeExamHeader({
  inSignUp,
  standalone,
}: {
  inSignUp: boolean;
  standalone: boolean;
}): boolean {
  return !inSignUp && !standalone;
}
